export default "__VITE_ASSET__CkUWDewG__"